import { Input } from "../../../../common/Input";
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import { EmployeePickerField } from "../../../../common/selectComponents/EmployeePicker";

export function DetailsTab({ form, handleInputChange, showGeneralMessage }) {

	const handleSelectManager = (employee) => {
		if (form.employees.some(sub => sub.employeePersonalInformationId === employee.id)) {
			showGeneralMessage(`${employee.fullName} is already a subordinate and cannot be the manager.`, false);
			return;
		}
		handleInputChange('employeePersonalInformationId', employee.id);
		handleInputChange('employeeData', {
			id: employee.id,
			fullName: employee.fullName,
			employeeId: employee.employeeId,
			department: employee.employeeInformationDepartmentDescription || "N/A",
			position: employee.employeeInformationPositionDescription || "N/A"
		});
	};

	return (
		<div className="space-y-6">
			<div className="border border-gray-300 rounded-lg bg-white px-4 py-4 shadow-sm">
				<h3 className="font-medium text-gray-700 border-b border-gray-200 pb-2 mb-4">Team Information</h3>
				<div className="grid grid-cols-1 gap-4">
					<Input
						label="Team Name (Optional):"
						value={form.teamName}
						onChange={(e) => handleInputChange('teamName', e.target.value)}
						placeholder="Enter Team Name"
					/>
					<EmployeePickerField
						label="Manager:"
						isRequired={true}
						employeePersonalInformationId={form.employeePersonalInformationId}
						displayValue={form.employeeData
							? `${form.employeeData.employeeId} - ${form.employeeData.fullName}`
							: ""}
						onSelect={handleSelectManager}
						onClear={() => {
							handleInputChange('employeePersonalInformationId', "");
							handleInputChange('employeeData', null);
						}}
						errorMessage="Please select a manager"
						allowClear={false}
					/>
				</div>
				{form.employeeData && (
					<div className="mt-4 bg-gray-50 p-4 rounded-lg border border-gray-200">
						<div className="flex items-center space-x-2 mb-2 text-blue-600">
							<SupervisorAccountIcon fontSize="small" /><span className="font-bold text-sm">Active Manager Profile</span>
						</div>
						<div className="grid grid-cols-2 gap-4 text-xs">
							<div><p className="text-gray-400 uppercase">Department</p><p className="font-semibold text-gray-600">{form.employeeData.department}</p></div>
							<div><p className="text-gray-400 uppercase">Position</p><p className="font-semibold text-gray-600">{form.employeeData.position}</p></div>
						</div>
					</div>
				)}
			</div>
			<div className="border border-gray-300 rounded-lg bg-white px-4 py-4 shadow-sm flex items-center">
				<input type="checkbox" id="isActive" checked={form.isActive} onChange={(e) => handleInputChange('isActive', e.target.checked)} className="h-4 w-4 rounded border-gray-300 text-blue-600 cursor-pointer" />
				<label htmlFor="isActive" className="ml-2 text-sm font-medium text-gray-600 cursor-pointer">Active Team</label>
			</div>
		</div>
	);
}